
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-seekers/training-and-apprenticeships/[url_slug]",
      function () {
        return require("private-next-pages/job-seekers/training-and-apprenticeships/[url_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-seekers/training-and-apprenticeships/[url_slug]"])
      });
    }
  